/* src/app/top-menu/top-menu.component.scss */
.navbar {
  border-color: #edf2f9;
}
/*# sourceMappingURL=top-menu.component.css.map */
